<template>
  <div>
    <keep-alive :include="cachedViews">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'PutInManage',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
  },
};
</script>
